import { SignShapeLayer } from './types';
export const SHAPE_CATALOG = [
  { kind: 'rectangle', label: 'Rectangle' }, { kind: 'rounded-rectangle', label: 'Rounded rectangle' },
  { kind: 'circle', label: 'Circle' }, { kind: 'ellipse', label: 'Ellipse' },
  { kind: 'triangle', label: 'Triangle' }, { kind: 'polygon', label: 'Polygon' },
  { kind: 'star', label: 'Star' }, { kind: 'line', label: 'Line' }, { kind: 'arrow', label: 'Arrow' },
  { kind: 'badge', label: 'Badge' }, { kind: 'divider', label: 'Divider' },
] as const;
export type ShapeKind = typeof SHAPE_CATALOG[number]['kind'];
export function createShapeLayer(kind: ShapeKind, transform: { x: number; y: number; width: number; height: number }): SignShapeLayer {
  const label = SHAPE_CATALOG.find(item => item.kind === kind)!.label;
  return { id: `shape-${kind}-${Date.now()}`, name: label, type: 'shape', visible: true, locked: false, opacity: 1,
    transform: { ...transform, rotation: 0 }, shape: { kind, ...(kind === 'rounded-rectangle' ? { cornerRadius: 18 } : {}) },
    fill: { type: 'solid', color: '#0f766e' } };
}
